<template>
  <div class="game-page">
    <div class="content-card">
      <div class="section">
        <div class="section-label">Style</div>
        <div class="section-content">
          <div class="tags">
            <button class="tag" type="button" :class="{active: selectedStyle === 'Internet celebrity'}" :aria-pressed="selectedStyle === 'Internet celebrity'" @click="selectedStyle = 'Internet celebrity'">Internet celebrity</button>
            <button class="tag" type="button" :class="{active: selectedStyle === 'Moderator'}" :aria-pressed="selectedStyle === 'Moderator'" @click="selectedStyle = 'Moderator'">Moderator</button>
            <button class="tag" type="button" :class="{active: selectedStyle === 'Model'}" :aria-pressed="selectedStyle === 'Model'" @click="selectedStyle = 'Model'">Model</button>
            <button class="tag" type="button" :class="{active: selectedStyle === 'Nurse'}" :aria-pressed="selectedStyle === 'Nurse'" @click="selectedStyle = 'Nurse'">Nurse</button>
            <button class="tag" type="button" :class="{active: selectedStyle === 'Secretary'}" :aria-pressed="selectedStyle === 'Secretary'" @click="selectedStyle = 'Secretary'">Secretary</button>
            <button class="tag" type="button" :class="{active: selectedStyle === 'Married woman'}" :aria-pressed="selectedStyle === 'Married woman'" @click="selectedStyle = 'Married woman'">Married woman</button>
            <button class="tag" type="button" :class="{active: selectedStyle === 'Student'}" :aria-pressed="selectedStyle === 'Student'" @click="selectedStyle = 'Student'">Student</button>
            <button class="tag" type="button" :class="{active: selectedStyle === 'Pregnant woman'}" :aria-pressed="selectedStyle === 'Pregnant woman'" @click="selectedStyle = 'Pregnant woman'">Pregnant woman</button>
            <button class="tag" type="button" :class="{active: selectedStyle === 'mother and daughter'}" :aria-pressed="selectedStyle === 'mother and daughter'" @click="selectedStyle = 'mother and daughter'">mother and daughter</button>
            <button class="tag" type="button" :class="{active: selectedStyle === 'Lolita'}" :aria-pressed="selectedStyle === 'Lolita'" @click="selectedStyle = 'Lolita'">Lolita</button>
          </div>
        </div>
      </div>

      <div class="section">
        <div class="section-label">Want</div>
        <div class="section-content">
          <div class="tags">
            <button class="tag" type="button" :class="{active: selectedWant === 'Trio'}" :aria-pressed="selectedWant === 'Trio'" @click="selectedWant = 'Trio'">Trio</button>
            <button class="tag" type="button" :class="{active: selectedWant === 'Arm relationship'}" :aria-pressed="selectedWant === 'Arm relationship'" @click="selectedWant = 'Arm relationship'">Arm relationship</button>
            <button class="tag" type="button" :class="{active: selectedWant === 'Spray'}" :aria-pressed="selectedWant === 'Spray'" @click="selectedWant = 'Spray'">Spray</button>
            <button class="tag" type="button" :class="{active: selectedWant === 'Sm'}" :aria-pressed="selectedWant === 'Sm'" @click="selectedWant = 'Sm'">Sm</button>
          </div>
        </div>
      </div>

      <van-button class="start-btn" type="primary" @click="startJourney">
        Start the journey of love
      </van-button>

      <div v-if="showLoading" class="loading-overlay">
        <div class="loading-lines">
          <div class="line line-1"></div>
          <div class="line line-2"></div>
        </div>
        <img src="/img/live/loading.png" class="loading-icon" alt="Loading">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedStyle: 'Internet celebrity',
      selectedWant: 'Trio',
      showLoading: false
    };
  },
  methods: {
    startJourney() {
      this.showLoading = true;
      setTimeout(() => {
        this.showLoading = false;
        this.$router.push('/lottery');
      }, 2000);
    }
  }
};
</script>

<style lang='less' scoped>
.game-page {
  min-height: 100vh;
  background: url('/img/live/game1.jpg');
  background-size: 100% 100vh;
  padding: 0.53333rem;
  padding-bottom: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.game-page::before,
.game-page::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  filter: blur(60px);
}

.game-page::before {
  width: 240px;
  height: 240px;
  top: 50px;
  left: -80px;
}

.game-page::after {
  width: 200px;
  height: 200px;
  bottom: 100px;
  right: -60px;
}

.content-card {
  background: #fff;
  border-radius: 0.53333rem;
  padding: 0.4rem;
  box-shadow: 0 0.2rem 0.8rem rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 1;
  width: 100%;
}

.section {
  margin-bottom: 0.3rem;
  display: flex;
  align-items: flex-start;
}

.section-label {
  font-size: 0.4rem;
  color: #666;
  font-weight: 500;
  min-width: 1.6rem;
  padding-top: 0.2rem;
}

.section-content {
  flex: 1;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.2rem;
}

.tag {
  display: inline-flex;
  min-height: 0.86rem;
  padding: 0.2rem 0.3rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.53333rem;
  font-size: 0.29rem;
  background: #fff;
  color: #666;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.3s;
}

.tag.active {
  background: var(--victoria-action) !important;
  color: #2a171d !important;
  border-color: rgba(255, 209, 217, 0.5) !important;
  box-shadow: 0 0.14rem 0.4rem rgba(207, 127, 145, 0.3);
}

.tag:focus-visible {
  outline: 2px solid var(--victoria-light-rose);
  outline-offset: 2px;
}

.start-btn {
  width: 100%;
  height: 1.06667rem;
  line-height: 1.06667rem;
  border-radius: 0.53333rem;
  font-size: 0.4rem;
  font-weight: 500;
  border: none;
  background: linear-gradient(to right, rgb(91, 96, 223) 0%, rgb(91, 96, 223) 100%);
  color: #fff;
  margin-top: 0.66667rem;
  box-shadow: 0 0.1rem 0.4rem rgba(123, 104, 238, 0.3);
}

::v-deep .van-button__text {
  color: #fff;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-lines {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 4rem;
  height: 4rem;
  z-index: 99;
}

.line {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 0.08rem solid rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  transform-style: preserve-3d;
}

.line-1 {
  animation: rotate3d-1 2s linear infinite;
}

.line-2 {
  animation: rotate3d-2 2s linear infinite;
}

@keyframes rotate3d-1 {
  0% {
    transform: rotateY(0deg) rotateX(60deg) scale(1);
    opacity: 1;
  }
  25% {
    transform: rotateY(90deg) rotateX(60deg) scale(0.5);
    opacity: 0.3;
  }
  50% {
    transform: rotateY(180deg) rotateX(60deg) scale(1);
    opacity: 1;
  }
  75% {
    transform: rotateY(270deg) rotateX(60deg) scale(0.5);
    opacity: 0.3;
  }
  100% {
    transform: rotateY(360deg) rotateX(60deg) scale(1);
    opacity: 1;
  }
}

@keyframes rotate3d-2 {
  0% {
    transform: rotateY(90deg) rotateX(60deg) scale(0.5);
    opacity: 0.3;
  }
  25% {
    transform: rotateY(180deg) rotateX(60deg) scale(1);
    opacity: 1;
  }
  50% {
    transform: rotateY(270deg) rotateX(60deg) scale(0.5);
    opacity: 0.3;
  }
  75% {
    transform: rotateY(360deg) rotateX(60deg) scale(1);
    opacity: 1;
  }
  100% {
    transform: rotateY(450deg) rotateX(60deg) scale(0.5);
    opacity: 0.3;
  }
}


.loading-icon {
  width: 300vw;
  height: 179%;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0% {
    transform: translate(30vw, 30vh);
  }
}
</style>
